import { Center, Text, Stack } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

function NoRecruiterComponent() {
  const { t } = useTranslation('moniterByRecruiters');

  return (
    <Center height="calc(100vh - 278px - 12.5rem)" px={4}>
      <Stack align="center" spacing={4}>
        <Text fontSize="lg">{t('recruiterSelect.notFound')}</Text>
      </Stack>
    </Center>
  );
}

export const NoRecruiter = React.memo(NoRecruiterComponent);
